import { apiClient as api } from "./httpClient";

export interface ProfTypeItem {
  id: string;
  name: string;
  inUse: boolean; // há UEPR usando este tipo na entidade -> não pode desvincular
}

export interface EntityProfessionalTypes {
  linked: ProfTypeItem[];
  available: ProfTypeItem[];
}

export const entityProfessionalTypeService = {
  getByEntity: async (entityId: string): Promise<EntityProfessionalTypes> => {
    const response = await api.get(`/entity-professional-types/by-entity/${entityId}`);
    return response.data;
  },
  link: async (entityId: string, professionalTypeId: string): Promise<void> => {
    await api.post(`/entity-professional-types/link`, { entityId, professionalTypeId });
  },
  unlink: async (entityId: string, professionalTypeId: string): Promise<void> => {
    await api.post(`/entity-professional-types/unlink`, { entityId, professionalTypeId });
  },
};
